import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { EnumDropdownItemVariant } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { analyticsExportFormats } from 'entities/Analytics'
import { type ExportAnalyticsModalStore } from 'pages/analytics/ui/ExportAnalyticsModal/store/exportAnalyticsModalStore'
import styles from './styles.module.scss'

type IExportAnalyticsModalContentProps = {
  store: ExportAnalyticsModalStore
}

export const ExportAnalyticsModalContent: FC<IExportAnalyticsModalContentProps> = observer(
  ({ store: { format, setFormat } }) => {
    return (
      <div className={styles.content}>
        <SelectField
          labelText={'Format'}
          items={analyticsExportFormats.map((format) => ({
            id: format,
            label: format.toUpperCase(),
            variant: EnumDropdownItemVariant.CheckedRight,
          }))}
          selectProps={{
            variant: 'stroke',
            textFieldPlaceholderProps: {
              size: 'medium',
            },
          }}
          value={format}
          setValue={setFormat}
        />
      </div>
    )
  }
)
